import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";


export const LandingPageConfigClientManager = (function ($) {

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onGetLandingPageConfig, function(){
		_onGetLandingPageConfig();
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onAddStaticResourceList, function(event){
		_onAddStaticResourcelList(event.id, event.caption);
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onAddDynamicResourceList, function(event){
		_onAddDynamicResourceList(event.id, event.caption);
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onAddExternalResourceList, function(event){
		_onAddExternalResourcelList(event.data);
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onRemoveResourceList, function(event){
		_onRemoveResourceList(event.id);
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onAddNewReleases, function(event){
		_onAddNewReleases(event.range, event.caption, event.name);
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onUpdateLandingPageConfig, function(event){//on re-order
		TLCLogger.log("onUpdateLandingPageConfig", event.data.resourceLists);
		_onReOrderConfiguration(event.data.resourceLists)
	});

	var _getBriefResources = function(resourceLists){//TODO perhaps this would be better in a util?
		var returnList = [];
		$.each(resourceLists, function(i, resourceList){
			returnList.push({
				id: resourceList.id,
				displayOrder: resourceList.displayOrder
			});
		});
		return returnList;
	};

	var _onReOrderConfiguration = function(resourceLists){
		var restUrl = "/landingPageConfiguration/reorder";
		var postData = {resourceLists: _getBriefResources(resourceLists)};
		_updateLandingPageConfiguration(restUrl, postData);
	};

	var _updateOrGetLandingPageConfiguration = function(restUrl, postData, responseEvent){
		var lists = null, success = false;
		TLCRest.jsonCall(restUrl, {
			postData: postData,
			callback: function(data){
				if(data !== null){
					lists = data;
					success = true;
				}
			},
			finallyHandler: function(){
				TLCEventManager.fireEvent(responseEvent, {success:success, data:lists});
			},
			timeout:       20000,
            cancellable:   true,
            cache:         false
		});
	};

	var _onGetLandingPageConfig = function(postData){
		var restUrl = "/landingPageConfiguration";
		var responseEvent = LS2PAC_CONSTANTS.Events.onGetLandingPageConfigResponse;
		_updateOrGetLandingPageConfiguration(restUrl, postData, responseEvent);
	};

	var _updateLandingPageConfiguration = function(restUrl, postData){
		var responseEvent = LS2PAC_CONSTANTS.Events.onUpdateLandingPageConfigResponse;
		_updateOrGetLandingPageConfiguration(restUrl, postData, responseEvent);
	};

	var _onReorderLandingPageConfig = function(config){
		//TODO
	};

	var _onAddExternalResourcelList = function(postData){
		_updateLandingPageConfiguration("/landingPageConfiguration/add/external", postData);
	};

	var _onRemoveResourceList = function(id){
		_updateLandingPageConfiguration("/landingPageConfiguration/remove/"+id);
	};

	var _onAddNewReleases = function(range, caption, name){
		_updateLandingPageConfiguration("/landingPageConfiguration/add/newReleases/"+range, {
			caption: caption,
			name: name
		});
	};

	var _onAddStaticResourcelList = function(id, caption){
		_updateLandingPageConfiguration("/landingPageConfiguration/add/"+id, {
			caption: caption
		});
	};

	var _onAddDynamicResourceList = function(id, caption){
		_updateLandingPageConfiguration("/landingPageConfiguration/add/"+id, {
				caption: caption
		});
	};

    return {

    };

})($);
